<template>
  <div class="">
    <longterm-stock v-if="tab === 'long-term-stock'"></longterm-stock>
    <product-available v-if="tab === 'product-available'"></product-available>
    <fba-product-sales v-if="tab === 'fba-product-sales'"></fba-product-sales>
    <settings v-if="tab === 'settings'"></settings>
  </div>
</template>
<script>
import LongtermStock from './LongtermStock'
import ProductAvailable from './ProductAvailable'
import FbaProductSales from './FbaProductSales'
import Settings from './Settings'

export default {
  components: {
    LongtermStock,
    ProductAvailable,
    FbaProductSales,
    Settings
  },
  props: {
    tab: {
      type: String,
      default: 'long-term-stock'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/salemonAgent/TabContent.vue